module.exports = __webpack_public_path__ + "voice-mute.svg?c18eed0fe92d8ad50b4c0616a514f8e9";